const FavouriteCount = (props) => {

    const {
        favs
    } = props;

  return favs.toLocaleString();
}

export default FavouriteCount